import { useCreditCardSetupContext } from '@apps/registry/admin/components/CreditCardSetup/CreditCardSetUp.context';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { hasActiveStripeAccount } from '@shared/utils/payoutAccount';
import { useShippingAddressAndCurrencyDialogsContext } from '../components/ShippingAddressAndCurrencyDialogsProvider';

export const useShouldShowConnectBankAccountButton = () => {
  const [isI18nEnabled] = useIsFeatureEnabled('registryCashFundCurrency18nEnabled');
  const { payoutAccountInfo, canManagePayouts, kycReady, isLocaleSupported } = useCreditCardSetupContext();
  const { registryShippingAddress } = useShippingAddressAndCurrencyDialogsContext();

  if (!canManagePayouts) return false;
  if (payoutAccountInfo && hasActiveStripeAccount(payoutAccountInfo.status)) return false;

  const hasUSShippingAddress = !!registryShippingAddress && registryShippingAddress.countryCode === 'USA';

  if (!isI18nEnabled) return hasUSShippingAddress;

  if (!kycReady) return false;
  return isLocaleSupported || hasUSShippingAddress;
};
